import type BookingServiceFormInfoType from 'owa-service/lib/contract/BookingServiceFormInfoType';
import type { BookingServiceFormInfo } from 'owa-graph-schema';

const mapBookingServiceFormInfoType = (
    bookingServiceFormInfos: BookingServiceFormInfoType[]
): BookingServiceFormInfo[] | undefined => {
    if (!bookingServiceFormInfos) {
        return;
    }
    const modifiedBookingServiceFormInfos = bookingServiceFormInfos.map(({ FormId, FormName }) => {
        return {
            formId: FormId as string,
            formName: FormName as string,
        };
    });

    return modifiedBookingServiceFormInfos;
};

export default mapBookingServiceFormInfoType;
